var app = angular.module('leonardo');

var ChargeCodeService = function(BaseRestService) {
  return new BaseRestService('charge-codes', function(RestangularConfigurer) {
    RestangularConfigurer.addElementTransformer('charge-codes', false, function(chargeCode) {
      chargeCode.addRestangularMethod('edit', 'patch');
      return chargeCode;
    });
  });
};

app.factory('ChargeCodeService', ['BaseRestService', ChargeCodeService]);
